<template>
  <div
    class="content-slide-layout-item"
    v-on="$listeners"
  >
    <div class="layout-thumbnail-image">
      <img :src="layout.layoutThumbnailImage" />
    </div>
    <p class="layout-name">
      {{ layout.name }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    layout: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>

.content-slide-layout-item {
  cursor: pointer;
  flex: 0 0 48%;
  margin: 1% 0 3%;

  &:nth-child(odd) {
    margin-left: 0;
    margin-right: 3%;
  }
  .layout-thumbnail-image, .layout-name {
    transition: all 0.2s ease;
  }
  .layout-thumbnail-image {
    @apply border border-secondary-20 rounded-lg transition-colors;
    display: block;
    width: 158px;
    height: 96px;
    margin-bottom: 8px;
    img {
      @apply rounded-lg;
      width: 100%;
      height: 100%;
    }
  }
  &:hover {
    .layout-thumbnail-image {
      @apply border-primary-90;
    }

    .layout-name {
      @apply text-primary-90;
    }
  }

}
</style>
